import React from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const HighDemandPackagesModal = ({ show, onHide, packagesData, totalPlayers }) => {
  const navigate = useNavigate();

  const handleShowMore = () => {
    onHide();
    navigate("/admin/package-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-chart-pie text-info me-2"></i>
          High Demand Packages
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded">
          <span className="text-muted fw-semibold">Total Enrolled Players Across Packages:</span>
          <span className="fs-18 fw-bold text-primary">{totalPlayers || 0}</span>
        </div>
        <div className="table-responsive">
          <Table hover responsive className="align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Package Name</th>
                <th className="text-center">Active Players</th>
                <th className="text-end">Share (%)</th>
              </tr>
            </thead>
            <tbody>
              {packagesData && packagesData.length > 0 ? (
                packagesData.map((item, idx) => {
                  const share =
                    totalPlayers > 0
                      ? ((Number(item?.count || item?.playerCount || 0) / totalPlayers) * 100).toFixed(1)
                      : "0.0";
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="fw-semibold">
                        {item?.name || item?.packageName || `Package ${idx + 1}`}
                      </td>
                      <td className="text-center fw-bold text-primary">
                        {item?.count || item?.playerCount || 0}
                      </td>
                      <td className="text-end fw-semibold text-muted">{share}%</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="text-center py-4 text-muted">
                    No package data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HighDemandPackagesModal;
